import React, { useContext, useEffect } from 'react';
import { ORDERS_PER_DAY, RUN_TEST_NOW, SCHEDULE_INFO, SESSION_PER_DAY } from '../../utils/Constants';
import TestConfiguration from './TestConfiguration';
import PromotionPreference from './PromotionPreference'; // Import the PromotionPreference component
import { TPayload } from '../../types/ab';
import { ABContext } from '../../contexts/ABContext';
import { runABTest } from '../../services/ABServices';
import { toast } from 'react-toastify';
import { areObjectsIdentical } from 'Pages/GMS/ISR/Components/RuleComponents/helper';
import { useHistory } from 'react-router-dom';
import DisplayBox from '../../components/DisplayBox';

type ScheduleSectionProps = {
    testId: string;
    onSave: () => Promise<boolean | undefined>
}

const ScheduleSection = ({ testId, onSave }: ScheduleSectionProps) => {
    const abContext = useContext(ABContext);
    const history = useHistory();

    useEffect(() => {
        if (abContext?.setPayload) {
            abContext.setPayload((prevPayload: TPayload) => ({
                ...prevPayload,
                estimated_orders_per_day: prevPayload?.estimated_orders_per_day,
                estimated_sessions_per_day: prevPayload?.estimated_sessions_per_day,
                test_duration: prevPayload?.test_duration
            }));
        }
    }, []);

    const handleRunAbTestClick = async () => {
        let updatedPayload = {...abContext?.payload}

        if (abContext?.payload?.win_threshold === undefined) {
            updatedPayload = { ...abContext?.payload, win_threshold: 0 }
        }

        if (!areObjectsIdentical(updatedPayload, abContext?.payloadNetworkCopy)) {
            const saved = await onSave();
            if (!saved) return;
        }
        let res = await runABTest(testId)
        if (res?.done) {
            toast.info(res?.message)
            history?.replace("/gms/ab")
        } else {
            toast.error(res?.message)
        }
    }

    if (!abContext?.payload?.estimated_orders_per_day) {
        return null;
    }

    return (
        <section>
            <label className='text-caption-style tw-text-[#747593] tw-mt-4'>{SCHEDULE_INFO}</label>
            <div className='tw-flex tw-flex-wrap tw-items-center tw-gap-4 tw-mt-4'>
                <DisplayBox displayText={SESSION_PER_DAY} value={abContext?.payload.estimated_sessions_per_day?.toString() ?? "NA"} />
                <DisplayBox displayText={ORDERS_PER_DAY} value={abContext?.payload.estimated_orders_per_day?.toString() ?? "NA"} />
                {/* <DisplayBox showChip={true} displayText={TEST_DURATION} value={abContext?.payload.test_duration ? `${Math.ceil(abContext?.payload?.test_duration)} Days` : "NA"} /> */}
            </div>
            <div className='tw-mt-4'><TestConfiguration /></div>
            
            
            <div className='tw-mt-6'>
                <PromotionPreference />
            </div>
            
            <div className='tw-flex tw-items-center tw-gap-3 tw-mt-8'>
                {/* <button className='outline-button'>{SCHEDULE}</button> */}
                <button disabled={abContext.payload?.test_duration === 0} onClick={handleRunAbTestClick} className='button-style'>{RUN_TEST_NOW}</button>
            </div>
        </section>
    );
}

export default ScheduleSection;